import React from 'react'
import getConfig from 'next/config'

import Router from 'next/router'
import { get, headers } from '../../lib/fetch'

import GlobalContext from '../../components/GlobalContext'
import { AccountConsumer } from '../../components/AccountProvider'
import { EventTrackingConsumer } from '../../components/EventTrackingProvider'
import DigitalClubEntryPoint from '../../components/DigitalClub/DigitalClubEntryPoint/DigitalClubEntryPoint'
import { getUserDcEligibility } from '../../utils/constants/dc_free_trial'

const {
  publicRuntimeConfig: { LOYALTY_API },
} = getConfig()

const MembershipRegistrationWrapper = props => (
  <GlobalContext.Consumer>
    {({ remoteConfig }) => (
      <EventTrackingConsumer>
        {({ track }) => (
          <AccountConsumer>
            {({ isLoggedIn, login }) => (
              <DigitalClubEntryPoint
                {...props}
                standAlonePage={true}
                remoteConfig={remoteConfig}
                isLoggedIn={isLoggedIn}
                login={login}
                track={track}
                getDcFreeTrialEligibility={getUserDcEligibility}
              />
            )}
          </AccountConsumer>
        )}
      </EventTrackingConsumer>
    )}
  </GlobalContext.Consumer>
)

MembershipRegistrationWrapper.getInitialProps = async ctx => {
  try {
    const dcmemberCheckRequest = get(
      `${LOYALTY_API}/memberships/status?programmeId=2`,
      {
        headers: headers(ctx, true),
      }
    )
    const [dcmemberCheckResponse] = await Promise.all([dcmemberCheckRequest])

    if (dcmemberCheckResponse?.dc?.active) {
      const membershipRegistrationUrl = '/membership/welcome'
      if (ctx.res) {
        ctx.res.writeHead(302, { Location: membershipRegistrationUrl })
        ctx.res.end()
      } else {
        Router.push(membershipRegistrationUrl)
      }
    }
    return {
      isDcMember: dcmemberCheckResponse?.dc?.active,
    }
  } catch (error) {
    return { isDcMember: false }
  }
}

export default MembershipRegistrationWrapper
